/* AQUARETTI v3 — arrival motion, slider, hero planes, pinned technology scrub, sets (bundles), accessories quick add. */
(function () {
  'use strict';
  if (window.__aqv3) return; window.__aqv3 = true; /* the assets snippet is rendered by every section; run once */
  var doc = document, root = doc.documentElement;
  root.classList.add('aqv3-js');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  /* ---------- arrival ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    doc.querySelectorAll('.aqv3 [data-aq-in]').forEach(function (el) { io.observe(el); });
  } else {
    doc.querySelectorAll('.aqv3 [data-aq-in]').forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- before / after slides (slides in a group move together) ---------- */
  var setPos = function (s, v) { s.style.setProperty('--pos', v + '%'); var r = s.querySelector('.aqv3-slide__range'); if (r && r.value != v) r.value = v; };
  var groups = [];
  doc.querySelectorAll('[data-aq-slidegroup]').forEach(function (g) { groups.push({ el: g, slides: [].slice.call(g.querySelectorAll('[data-aq-slide]')), touched: false }); });
  doc.querySelectorAll('[data-aq-slide]').forEach(function (s) { if (!s.closest('[data-aq-slidegroup]')) groups.push({ el: s, slides: [s], touched: false }); });
  groups.forEach(function (grp) {
    var apply = function (v) { grp.slides.forEach(function (s) { setPos(s, v); }); grp.el.classList.toggle('is-after', v > 50); };
    grp.slides.forEach(function (s) {
      var r = s.querySelector('.aqv3-slide__range'); if (!r) return;
      r.addEventListener('input', function () { grp.touched = true; apply(r.value); });
      r.addEventListener('pointerdown', function () { grp.touched = true; });
    });
    apply(50);
    if (reduce || !('IntersectionObserver' in window)) return;
    var seen = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        seen.disconnect();
        var t0 = null;
        var tick = function (ts) {
          if (grp.touched) return;
          if (!t0) t0 = ts;
          var p = Math.min(1, (ts - t0) / 2600);
          var v = 50 - 30 * Math.sin(p * Math.PI);   // out to Month 3 and back
          apply(v);
          if (p < 1) requestAnimationFrame(tick);
        };
        setTimeout(function () { requestAnimationFrame(tick); }, 450);
      });
    }, { threshold: 0.35 });
    seen.observe(grp.el);
  });

  /* ---------- hero planes ---------- */
  var hero = doc.querySelector('[data-aq-hero]');
  if (hero && !reduce) {
    var plate = hero.querySelector('.aqv3-hero__plate'), prod = hero.querySelector('.aqv3-hero__product'),
        copy = hero.querySelector('.aqv3-hero__copy'), mist = hero.querySelector('.aqv3-hero__mist');
    var ticking = false;
    var upd = function () {
      ticking = false;
      var y = window.scrollY || 0, h = hero.offsetHeight || 1;
      if (y > h * 1.3) return;
      var mobile = window.innerWidth < 901;
      if (plate) plate.style.transform = 'translate3d(0,' + (y * 0.16).toFixed(1) + 'px,0)';
      if (mobile) return;
      if (prod) prod.style.transform = 'translate3d(0,' + (-y * 0.05).toFixed(1) + 'px,0) scale(' + (1 + y * 0.00005).toFixed(4) + ')';
      if (copy) { copy.style.transform = 'translate3d(0,' + (y * 0.24).toFixed(1) + 'px,0)'; copy.style.opacity = Math.max(0, 1 - y / (h * 0.75)).toFixed(3); }
      if (mist) mist.style.transform = 'translate3d(0,' + (y * 0.36).toFixed(1) + 'px,0)';
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }

  /* ---------- technology demonstration: pinned scrub ---------- */
  doc.querySelectorAll('[data-aq-tech]').forEach(function (sec) {
    var track = sec.querySelector('.aqv3-tech__track');
    if (!track) return;
    if (reduce) { sec.classList.add('is-static'); sec.style.setProperty('--p', 1); return; }
    // sticky offset for a sticky host header
    var hdr = doc.querySelector('.aqmv-header.is-sticky, header.shopify-section-header-sticky, .section-header.shopify-section-header-sticky');
    var off = hdr ? hdr.getBoundingClientRect().height : 0;
    sec.style.setProperty('--header', off + 'px'); root.style.setProperty('--aqv3-header', off + 'px');
    var ticking = false;
    var upd = function () {
      ticking = false;
      var rect = track.getBoundingClientRect();
      var vh = window.innerHeight;
      var total = track.offsetHeight - vh + off;
      var p = total > 0 ? (-rect.top + off) / total : 1;
      p = Math.max(0, Math.min(1, p));
      sec.style.setProperty('--p', p.toFixed(4));
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(upd); } }, { passive: true });
    window.addEventListener('resize', upd);
    sec.style.setProperty('--p', 0);
    upd();
  });


  /* ---------- tech: water path geometry (v3.2) ---------- */
  doc.querySelectorAll('svg[data-aq-flow]').forEach(function (svg) {
    var vb = svg.viewBox.baseVal, W = vb.width || 80, H = vb.height || 100;
    var P = function (str) { return (str || '').trim().split(/\s+/).filter(Boolean).map(function (t) { var a = t.split(',').map(Number); return { x: a[0] * W / 100, y: a[1] * H / 100 }; }); };
    var pts = P(svg.getAttribute('data-aq-flow')); if (pts.length < 2) return;
    var cartIdx = svg.getAttribute('data-cart'); cartIdx = cartIdx === '' || cartIdx === null ? -1 : +cartIdx;
    var turns = +svg.getAttribute('data-turns') || 5, amp = (+svg.getAttribute('data-amp') || 8) * W / 100;
    var f = function (p) { return p.x.toFixed(2) + ',' + p.y.toFixed(2); };
    var d = 'M ' + f(pts[0]), back = '', i;
    var helix = function (a, b) {
      var dx = b.x - a.x, dy = b.y - a.y, L = Math.hypot(dx, dy) || 1, ux = dx / L, uy = dy / L, px = -uy, py = ux;
      var at = function (t, side) { return { x: a.x + ux * t + px * amp * side, y: a.y + uy * t + py * amp * side }; };
      var seg = L / (turns + 0.5), t0 = seg * 0.25, s = '', k;
      s += ' C ' + f(at(seg * 0.1, 0)) + ' ' + f(at(t0 - seg * 0.1, -1)) + ' ' + f(at(t0, -1));
      for (k = 0; k < turns; k++) {
        var tA = t0 + k * seg, tM = tA + seg / 2, tB = tA + seg;
        s += ' C ' + f(at(tA + seg * 0.25, -1)) + ' ' + f(at(tA + seg * 0.25, 1)) + ' ' + f(at(tM, 1));
        var bh = ' C ' + f(at(tM + seg * 0.25, 1)) + ' ' + f(at(tM + seg * 0.25, -1)) + ' ' + f(at(tB, -1));
        s += bh; back += ' M ' + f(at(tM, 1)) + bh;
      }
      s += ' C ' + f(at(L - seg * 0.15, -1)) + ' ' + f(at(L - seg * 0.1, 0)) + ' ' + f(at(L, 0));
      return s;
    };
    for (i = 1; i < pts.length; i++) { if (i - 1 === cartIdx) d += helix(pts[i - 1], pts[i]); else d += ' L ' + f(pts[i]); }
    var ns = 'http://www.w3.org/2000/svg';
    var mk = function (tag, attrs) { var el = doc.createElementNS(ns, tag); Object.keys(attrs).forEach(function (k) { el.setAttribute(k, attrs[k]); }); svg.appendChild(el); return el; };
    mk('path', { 'class': 'aqv3-tech__glow', d: d });
    mk('path', { 'class': 'aqv3-tech__line', d: d });
    if (back) mk('path', { 'class': 'aqv3-tech__back', d: back });
    var ring = (svg.getAttribute('data-ring') || '').split(',').map(Number), out = (svg.getAttribute('data-out') || '').split(',').map(Number);
    if (ring.length >= 4 && !isNaN(ring[0])) {
      var cx = ring[0] * W / 100, cy = ring[1] * H / 100, rx = ring[2] * W / 100, ry = ring[3] * H / 100, rot = (ring[4] || 0) * Math.PI / 180;
      var radial = isNaN(out[0]), rl = radial ? ((out[1] || 8) * H / 100) : 0;
      var ox = radial ? 0 : (out[0] || 0) * W / 100, oy = radial ? 0 : (out[1] || 8) * H / 100;
      var halo = mk('ellipse', { 'class': 'aqv3-tech__halo', cx: cx, cy: cy, rx: rx * 0.92, ry: ry * 0.92 });
      halo.setAttribute('transform', 'rotate(' + (ring[4] || 0) + ' ' + cx + ' ' + cy + ')');
      var n = 9;
      for (i = 0; i < n; i++) {
        var th = (i / n) * Math.PI * 2, ex = Math.cos(th) * rx, ey = Math.sin(th) * ry;
        var sx = cx + ex * Math.cos(rot) - ey * Math.sin(rot), sy = cy + ex * Math.sin(rot) + ey * Math.cos(rot);
        var len = 0.85 + 0.35 * ((i * 7) % 5) / 4, dx = ox * len, dy = oy * len;
        if (radial) { var nx = sx - cx, ny = sy - cy, nl = Math.hypot(nx, ny) || 1; dx = nx / nl * rl * len; dy = ny / nl * rl * len; }
        mk('path', { 'class': 'aqv3-tech__spray', style: '--k:' + i, d: 'M ' + sx.toFixed(2) + ',' + sy.toFixed(2) + ' l ' + dx.toFixed(2) + ',' + dy.toFixed(2) });
      }
    }
  });

  /* ---------- reviews filter ---------- */
  doc.querySelectorAll('[data-aq-reviews]').forEach(function (sec) {
    var btns = sec.querySelectorAll('.aqv3-reviews__filter'), cards = sec.querySelectorAll('.aqv3-review');
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var tag = b.getAttribute('data-tag');
        cards.forEach(function (c) { c.classList.toggle('is-hidden', tag !== 'all' && c.getAttribute('data-tag') !== tag); });
      });
    });
  });

  /* ---------- owner videos: play when in view, one sound at a time ---------- */
  var ugcVids = [].slice.call(doc.querySelectorAll('[data-aq-ugc-video]'));
  if (ugcVids.length && 'IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (es) { es.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); } }); }, { threshold: 0.35 });
    ugcVids.forEach(function (v) { vo.observe(v); });
  }
  doc.addEventListener('click', function (e) {
    var b = e.target.closest('[data-aq-ugc-sound]'); if (!b) return;
    var v = b.parentNode.querySelector('video'); if (!v) return;
    var wasMuted = v.muted;
    ugcVids.forEach(function (o) { o.muted = true; var ob = o.parentNode.querySelector('[data-aq-ugc-sound]'); if (ob) { ob.setAttribute('aria-pressed', 'false'); ob.setAttribute('aria-label', 'Turn sound on'); } });
    if (wasMuted) { v.muted = false; b.setAttribute('aria-pressed', 'true'); b.setAttribute('aria-label', 'Turn sound off'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  });

  /* ---------- buy-box clips: click to play, one at a time, never autoplay (v3.3) ---------- */
  var clipCards = [].slice.call(doc.querySelectorAll('[data-aq-clips] .aqv3-clips__card'));
  if (clipCards.length) {
    var stopClip = function (c) { var v = c.querySelector('video'); if (v && !v.paused) v.pause(); c.classList.remove('is-playing'); var b = c.querySelector('[data-aq-clip-toggle]'); if (b) b.setAttribute('aria-label', 'Play ' + (v ? v.getAttribute('aria-label') || '' : '')); };
    clipCards.forEach(function (c) {
      var v = c.querySelector('video'), b = c.querySelector('[data-aq-clip-toggle]'); if (!v) return;
      var toggle = function (e) {
        e.preventDefault();
        if (v.paused) { clipCards.forEach(function (o) { if (o !== c) stopClip(o); }); v.muted = false; var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); }); c.classList.add('is-playing'); if (b) b.setAttribute('aria-label', 'Pause ' + (v.getAttribute('aria-label') || '')); }
        else { stopClip(c); }
      };
      v.addEventListener('click', toggle); if (b) b.addEventListener('click', toggle);
      v.addEventListener('ended', function () { stopClip(c); });
    });
  }

  /* ---------- cart helpers ---------- */
  var toastEl;
  var toast = function (msg) {
    if (!toastEl) { toastEl = doc.createElement('div'); toastEl.className = 'aqv3-toast'; doc.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  };
  var cartUI = function () { return doc.querySelector('cart-drawer') || doc.querySelector('cart-notification'); };
  var applyCode = function (code) {
    if (!code) return Promise.resolve(null);
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ discount: code }) })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  };
  var addItems = function (items, code) {
    var ui = cartUI();
    var body = { items: items };
    if (ui && ui.getSectionsToRender) {
      body.sections = ui.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function (res) {
        return applyCode(code).then(function (cart) {
          if (cart && ui && ui.getSectionsToRender) {
            // re-fetch rendered sections so the drawer shows the discounted cart
            var ids = ui.getSectionsToRender().map(function (s) { return s.id; }).join(',');
            return fetch(window.location.pathname + '?sections=' + ids).then(function (r) { return r.json(); }).then(function (sections) { res.sections = sections; return res; }).catch(function () { return res; });
          }
          return res;
        });
      })
      .then(function (res) {
        if (ui && ui.renderContents) { try { ui.renderContents(res); } catch (e) { window.location.href = '/cart'; } }
        else { window.location.href = '/cart'; }
        return res;
      });
  };
  window.AQV3 = { addItems: addItems, applyCode: applyCode, toast: toast };

  /* ---------- set (bundle) buttons anywhere on the page ---------- */
  doc.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aq-add]');
    if (!btn) return;
    e.preventDefault();
    var items;
    try { items = JSON.parse(btn.getAttribute('data-aq-add')); } catch (err) { return; }
    var code = btn.getAttribute('data-aq-code') || '';
    var label = btn.textContent;
    btn.classList.add('is-busy'); btn.setAttribute('aria-busy', 'true');
    addItems(items, code).then(function () {
      btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy');
      toast(btn.getAttribute('data-aq-done') || 'Added to your cart');
    }).catch(function (err) {
      btn.classList.remove('is-busy'); btn.removeAttribute('aria-busy');
      toast(err.message || 'Something went wrong');
    });
  });

  /* ---------- buy box: set selector hijacks the product form when a set is chosen ---------- */
  var setBox = doc.querySelector('[data-aq-setbox]');
  var inCartUI = function (el) { return !!el.closest('cart-drawer, cart-notification, .cart-upsell'); };
  var mainForm = function () { var fs = doc.querySelectorAll('form[data-type="add-to-cart-form"]'); for (var i = 0; i < fs.length; i++) { if (!inCartUI(fs[i])) return fs[i]; } return null; };
  if (setBox) {
    var chosen = function () { return setBox.querySelector('input[name="aqv3-set"]:checked'); };
    var syncPrice = function () {
      var o = chosen(); if (!o) return;
      var opt = o.closest('.aqv3-bb__opt');
      var now = opt.getAttribute('data-now');
      doc.querySelectorAll('[data-aq-setprice]').forEach(function (el) { el.textContent = now; });
      var cents = parseInt(opt.getAttribute('data-cents') || '0', 10), inst = doc.querySelector('[data-aq-installment]');
      if (inst && cents) inst.textContent = money(Math.round(cents / 4));
      var f = mainForm(), btn = f && f.querySelector('button[type="submit"] span');
      if (btn && btn.getAttribute('data-aq-label') == null) btn.setAttribute('data-aq-label', btn.textContent);
      if (btn) btn.textContent = (o.value === 'solo') ? btn.getAttribute('data-aq-label') : (opt.getAttribute('data-cta') || 'Add set to cart');
    };
    setBox.addEventListener('change', syncPrice);
    syncPrice();
    doc.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('form[data-type="add-to-cart-form"]') || inCartUI(form)) return;
      var o = chosen();
      if (!o || o.value === 'solo') return;
      e.preventDefault(); e.stopImmediatePropagation();
      var opt = o.closest('.aqv3-bb__opt');
      var items = JSON.parse(opt.getAttribute('data-items'));
      var code = opt.getAttribute('data-code') || '';
      var sub = form.querySelector('button[type="submit"]');
      if (sub) { sub.classList.add('loading'); sub.setAttribute('aria-disabled', 'true'); }
      addItems(items, code).then(function () {
        if (sub) { sub.classList.remove('loading'); sub.removeAttribute('aria-disabled'); }
      }).catch(function (err) {
        if (sub) { sub.classList.remove('loading'); sub.removeAttribute('aria-disabled'); }
        toast(err.message || 'Something went wrong');
      });
    }, true);
  }
})();
